<template>
  <div class="page-menu-m">
    <!-- 导航 -->
    <div class="menu-wrap">
      <ul class="menu-shade" v-if="isOpenShade">
        <li
          v-for="(v) in navs"
          :key="v.id"
          @click="jump(v)"
          class="shade-li ui-flex ui-flex-align-center"
          
        >
          <i class="shade-li-icon"
          :class="{
            'shade-li-index':v.index,
            'shade-li-about':v.about,
            'shade-li-productCenter':v.productCenter,
            'shade-li-try':v.try,
            'shade-li-contactUs':v.contactUs,
            'shade-li-active':v.isActive,
            }"
          ></i>
          <span class="shade-li-word"
            :class="{
            'shade-li-active':v.isActive,
            }"
          >{{ v.name }}</span>
        </li>
      </ul>
      <div class="menu-arrow" v-if="isOpenShade"></div>
      <div class="menu-btn ui-flex ui-flex-column ui-flex-justify-center ui-flex-align-center" @click.stop="openShade">
          <span>{{currentName1}}</span>
          <span>{{currentName2}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";

export default {
  props: ["path"],
  name: "Menu",
  data() {
    return {
      navs: [
        {
          id: 0,
          name: "首页",
          path: "/index_m",
          isActive: true,
          index: true,
          about: false,
          productCenter: false,
          try: false,
          contactUs: false
        },
        {
          id: 1,
          name: "关于我们",
          path: "/about_m",
          isActive: false,
          index: false,
          about: true,
          productCenter: false,
          try: false,
          contactUs: false
        },
        {
          id: 2,
          name: "产品中心",
          path: "/productCenter_m",
          isActive: false,
          index: false,
          about: false,
          productCenter: true,
          try: false,
          contactUs: false
        },
        {
          id: 3,
          name: "免费试用",
          path: "/try_m",
          isActive: false,
          index: false,
          about: false,
          productCenter: false,
          try: true,
          contactUs: false
        },
        {
          id: 4,
          name: "联系我们",
          path: "/contactUs_m",
          isActive: false,
          index: false,
          about: false,
          productCenter: false,
          try: false,
          contactUs: true
        }
      ],
      isOpenShade: false,
      currentName1:'首页',
       currentName2:'',
    };
  },
  created() {
    //初始化导航样式
    this.navs.map((v, i, a) => {
      if (this.path === v.path) {
        v.isActive = true;
        this.currentName1=v.name.slice(0,2)
        this.currentName2=v.name.slice(2,4)
      } else {
        v.isActive = false;
        v.currentName1='首页'
        v.currentName2=''
      }
    });
  },
  methods: {
    /**
     * 点击跳转
     */
    jump(value) {
      if (value.path) {
        router
          .push({
            path: value.path
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    openShade() {
      this.isOpenShade = !this.isOpenShade;
    },
    closeShade() {
      this.isOpenShade = false;
    }
  }
};
</script>

<style lang="scss">
@import "./style.scss";
</style>